import api from "../utils/axios";
import { getDataSourceStore } from "../utils/devextreme-grid";

import { HOST_API } from "../config-global";

const baseUrl = `/api/audits/`;

export function getEntityGrid(entityName, entityId) {
  return getDataSourceStore(`${HOST_API}${baseUrl}${entityName}/${entityId}`);
}

export function getGrid() {
  return getDataSourceStore(`${HOST_API}${baseUrl}`);
}
